/**
 {
    method: "GET",
    path: "/underwriting/user_pipeline",
    title: "Fetch User Pipeline",
    description: "Returns an array of loans.",
    purpose:
      "Retrieves the loan pipeline for a specific user. If user role is admin, all loans are returned.",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: null,
  },
 */
export const borrowerSubmissionEnpointsConfig = [
  {
    //createApplication
    method: "POST",
    path: "/borrower_submissions/new_application",
    title: "Create Loan Application",
    description: "Creates a new loan application submission.",
    purpose:
      "Does not require authentication or bearer token. Included query parameters that tie this loan application to a specific salesperson and/or loan",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: null,
    // NEED TO ADD
    formData: true,
    includeQueryParams: true,
  },
  {
    //createCreditAuthorization
    method: "POST",
    path: "/borrower_submissions/new_credit_authorization",
    title: "Create Credit Authorization",
    description: "Creates a new credit authorization submission",
    purpose:
      "Does not require authentication or bearer token. Included query parameters that tie this credit authorization to a specific salesperson and/or loan",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: null,
    // NEED TO ADD
    formData: true,
    includeQueryParams: true,
  },
  {
    //getApplicationById
    method: "GET",
    path: "/borrower_submissions/get_application/{appId}",
    title: "Get Loan Application",
    description: "Retrieves the data of a loan application.",
    // purpose: "Fetches the loan application status for a specific borrower.",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: null,
  },
  {
    //getCreditAuthorizationById
    method: "GET",
    path: "/borrower_submissions/get_credit_authorization/{appId}",
    title: "Get Credit Authorization",
    description: "Retrieves the data of a credit authorization.",
    // purpose: "Fetches the credit authorization status for a specific borrower.",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: null,
  },
  {
    //getApplications
    method: "GET",
    path: "/borrower_submissions/get_applications",
    title: "Get Loan Applications",
    description: "Retrieves list of all loan applications.",
    // purpose: "Fetches the loan application status for a specific borrower.",
    examplePath: null,
    requiredParams: null,
    requestPayload: null,
    requestResponse: null,
  },
];
